import { Component, Input, OnInit } from '@angular/core';
import { IErrorDescription } from '@ibank-globals/error';
import { finalize } from 'rxjs/operators/finalize';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ErrorHandler } from '../../../globals/classes/errorHandler';
import {
	ICardLoginRequest,
	ICreateApplicationRequest,
} from '../../classes/existing-onboarding-customer/requests';
import {
	CreateApplicationResponse,
	GetRegisteredMobileNumbersResponse,
	ICardLoginResponse,
	ICreateApplicationResponse,
	IGetRegisteredMobileNumbersResponse,
} from '../../classes/existing-onboarding-customer/responses';
import { UserAuth } from '../../classes/userAuth';
import { ExistingOnboardingCustomerService } from '../../services/existing-recovery/customer.service';
import { ConfirmPersonalDetailsModalComponent } from '../confirm-personal-details-modal/confirm-personal-details-modal.component';
import { ExistingIbankModalComponent } from '../existing-ibank-modal/existing-ibank-modal.component';
import { IBankCredentialsModalComponent } from '../ibank-credentials-modal/ibank-credentials-modal.component';
import { SourceApis } from '../../../globals/classes/errorDescription';
import { ErrorMessageModalComponent } from '../error-message-modal/error-message-modal.component';
import { CardModalComponent } from '../card-modal/card-modal.component';
import { ContactInfoModalComponent } from '../contact-info-modal/contact-info-modal.component';
import { BehaviorSubject } from 'rxjs';
import { ForgetCredentialsRetailModalComponent } from '../forget-credentials-retail-modal/forget-credentials-retail-modal.component';
import { AppSettings } from '../../app.settings';
import { BaseComponent } from '../../../globals/classes/base.component';
const uuid = require('uuid/v4');

@Component({
	selector: 'card-details-modal',
	template: require('./card-details-modal.component.html'),
})
export class CardDetailsModalComponent extends BaseComponent implements OnInit {
	public acceptedCards: boolean = false;
	public incorrectCard: boolean = false;

	public existingCustomer: boolean = false;
	public isLoading = false;
	public isCreateAppLoading: boolean = false;

	public isValidCard: boolean;
	public isValidPin: boolean;
	public cardLoginRequest: ICardLoginRequest;
	public isNewErrorModal: boolean = AppSettings.isNewErrorModalEnabled;
	public dynatraceForExistingOnBoarding: boolean = AppSettings.dynatraceForExistingOnBoarding;

	@Input() public createApplicationRequest: ICreateApplicationRequest;
	@Input() public isCardModalflow: boolean = false;
	@Input() public isForgetCredentialsRetailModalflow: boolean = false;

	private _invalidCredentials = new BehaviorSubject<boolean>(false);
	public readonly invalidCredentials$ = this._invalidCredentials.asObservable();

	constructor(private activeModal: NgbActiveModal, private modalService: NgbModal) {
		super();
	}

	public get canContinue(): boolean {
		return this.isValidCard && this.isValidPin;
	}

	public ngOnInit(): void {
		this.initRequests();
	}

	public closeModal(): void {
		this.activeModal.close();
	}

	public continue(): void {
		if (this.dynatraceForExistingOnBoarding) this._setCardDetailsDynatraceEvent();
		this.invokeCardLogin();
	}

	private _setCardDetailsDynatraceEvent() {
		this.setDynatraceEvent('ECO_Enter_Card_Details');
	}

	public cardValidityUpdated(isValid: boolean): void {
		this.isValidCard = isValid;
		this.isValidPin = isValid;
	}
	public toggleAcceptedCards() {
		this.acceptedCards = !this.acceptedCards;
	}

	public moveBack(): void {
		if (this.isCardModalflow) this.toggleCardModal();
		else if (this.isForgetCredentialsRetailModalflow) this.toggleForgetCredentialsRetaiModal();
		else this.toggleIBankCredentials();
	}

	public toggleCardModal(): void {
		this.activeModal.close();
		this.modalService.open(CardModalComponent, {
			windowClass: 'modal-small',
		});
	}
	public toggleForgetCredentialsRetaiModal(): void {
		this.activeModal.close();
		this.modalService.open(ForgetCredentialsRetailModalComponent, {
			windowClass: 'modal-small',
		});
	}

	public toggleIBankCredentials(): void {
		this.activeModal.close();
		this.modalService.open(IBankCredentialsModalComponent, {
			windowClass: 'modal-small',
		});
	}

	private initRequests(): void {
		this.cardLoginRequest = {
			applicationId: uuid(),
			cardNumber: '',
			cardPIN: '',
			userId: null
		};
		this.createApplicationRequest = {
			appId: this.cardLoginRequest.applicationId,
			customerCode: 0,
			cardNumber: '',
		};
	}

	private invokeCardLogin(): void {
		if (!this.isValidCard) return;
		this.isLoading = true;

		UserAuth.cardLogin(this.cardLoginRequest)
			.pipe(finalize(() => (this.isLoading = false)))
			.subscribe(
				(result) => this.handleUserCardResponse(result),
				(error) => this.handleCardLoginError(error, SourceApis.Identity)
			);
	}

	private handleUserCardResponse(response: ICardLoginResponse) {
		if (!!response) {
			this.goToCreateApplication(response);
		}
	}
	private handleCardLoginError(error: IErrorDescription, sourceApi: SourceApis): void {
		if (error.code == '1001' && !this.isNewErrorModal) {
			this._invalidCredentials.next(true);
			const modalRef = this.modalService.open(ErrorMessageModalComponent, {
				windowClass: 'modal-xs',
			});
			(modalRef.componentInstance as ErrorMessageModalComponent).wrongCardPin = true;
		} else ErrorHandler.newError(error);
	}
	private handleError(error: IErrorDescription, sourceApi: SourceApis): void {
		ErrorHandler.newError(error);
	}

	private goToCreateApplication(response: ICardLoginResponse) {
		if (!response || !response.userProfile) {
			console.log('invalid response, cannot proceed');
		}

		const req: ICreateApplicationRequest = {
			appId: response.applicationId,
			customerCode: Number.parseInt(response.userProfile.customerCode),
			cardNumber: response.userProfile.cardNumber,
		};
		this.isCreateAppLoading = true;
		ExistingOnboardingCustomerService.createApplication(req)
			.pipe(finalize(() => (this.isCreateAppLoading = false)))
			.subscribe(
				(result) => this.handleCreateAppResponse(result),
				(error) => this.handleErrorCreateApp(error)
			);
	}
	private handleErrorCreateApp(error: IErrorDescription): void {
		if (error.code == '7004') {
			if (this.isCardModalflow == true || this.isForgetCredentialsRetailModalflow == true)
				this.invokeRegisteredMobileNumber();
			else this.toggleExistingIbank();
		} else this.handlecreateApplicationError(error, SourceApis.Onboarding);
	}
	private handlecreateApplicationError(error: IErrorDescription, sourceApi: SourceApis): void {
		if (error.code == '1012' && !this.isNewErrorModal) {
			this.toggleErrorMessageModal();
		} else if ((error.code == '1020' || error.code == '5013') && !this.isNewErrorModal) {
			this.toggleErrorMessageModalUnconfirmDocuments();
		} else ErrorHandler.newError(error, sourceApi);
	}
	private toggleErrorMessageModal() {
		const modalRef = this.modalService.open(ErrorMessageModalComponent, {
			windowClass: 'modal-small',
		});
		(modalRef.componentInstance as ErrorMessageModalComponent).noMobileNumber = true;
	}
	private toggleErrorMessageModalUnconfirmDocuments() {
		const modalRef = this.modalService.open(ErrorMessageModalComponent, {
			windowClass: 'modal-small',
		});
		(modalRef.componentInstance as ErrorMessageModalComponent).confirmationDocumentsNotFound = true;
	}

	private handleCreateAppResponse(response: ICreateApplicationResponse) {
		if (!!response) {
			this.goToConfirmPersonalDetails(response);
		}
	}
	private goToConfirmPersonalDetails(response: ICreateApplicationResponse) {
		this.activeModal.close();
		const modalRef = this.modalService.open(ConfirmPersonalDetailsModalComponent, {
			windowClass: 'modal-small',
		});
		(modalRef.componentInstance as ConfirmPersonalDetailsModalComponent).appResponse = new CreateApplicationResponse(
			response
		);
		(modalRef.componentInstance as ConfirmPersonalDetailsModalComponent).isCardModalflow = this.isCardModalflow;
		(modalRef.componentInstance as ConfirmPersonalDetailsModalComponent).isForgetCredentialsRetailModalflow = this.isForgetCredentialsRetailModalflow;
	}

	private toggleExistingIbank() {
		this.activeModal.close();
		const modalRef = this.modalService.open(ExistingIbankModalComponent, {
			windowClass: 'modal-small',
		});
		(modalRef.componentInstance as ExistingIbankModalComponent).isExistingCustomer = true;
		(modalRef.componentInstance as ExistingIbankModalComponent).appRequest = this.createApplicationRequest;
	}

	private invokeRegisteredMobileNumber(): void {
		if (!this.createApplicationRequest.appId) return;
		this.isLoading = true;
		ExistingOnboardingCustomerService.getRegisteredMobileNumbers(
			this.createApplicationRequest.appId
		)
			.pipe(finalize(() => (this.isLoading = false)))
			.subscribe(
				(result) => this.handleRegisteredMobileNumberResponse(result),
				(error) => this.handleError(error, SourceApis.Onboarding)
			);
	}
	private handleRegisteredMobileNumberResponse(response: IGetRegisteredMobileNumbersResponse) {
		if (!!response) {
			this.toggleContactInfoModal(response);
		}
	}

	private toggleContactInfoModal(response: IGetRegisteredMobileNumbersResponse) {
		this.activeModal.close();
		const modalRef = this.modalService.open(ContactInfoModalComponent, {
			windowClass: 'modal-small',
		});
		(modalRef.componentInstance as ContactInfoModalComponent).getRegisteredMobileNumbersResponse = new GetRegisteredMobileNumbersResponse(
			response
		);
		(modalRef.componentInstance as ContactInfoModalComponent).appRequest = this.createApplicationRequest;
		(modalRef.componentInstance as ContactInfoModalComponent).isExistingCustomer = true;
		(modalRef.componentInstance as ContactInfoModalComponent).isCardModalflow = this.isCardModalflow;
		(modalRef.componentInstance as ContactInfoModalComponent).isForgetCredentialsRetailModalflow = this.isForgetCredentialsRetailModalflow;
	}
}
